import { GridWinHighlightActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { WinSequencePresenter } from "./WinSequencePresenter";

/** `grid_win_highlight` → the win sequence (decision 46): the beat, the cue, the dim, the winners' effect, the label. */
export function createWinHighlightPlugin(deps: { presenter: WinSequencePresenter }): ReplayPlugin {
  return {
    name: "win-highlight",
    actionHandlers: [new GridWinHighlightActionHandler((input) => deps.presenter.presentGridWinHighlight(input))],
  };
}
